/**
 * @generated SignedSource<<9e3c356a2b9b00fe4e574e656805fe2f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "Service",
    "kind": "LinkedField",
    "name": "serviceById",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "version",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "description",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "tags",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "labels",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useServiceLabelsServiceByIdQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useServiceLabelsServiceByIdQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "70fdabd85dd303cdfbf17d0d297fa27f",
    "id": null,
    "metadata": {},
    "name": "useServiceLabelsServiceByIdQuery",
    "operationKind": "query",
    "text": "query useServiceLabelsServiceByIdQuery(\n  $id: String\n) {\n  serviceById(id: $id) {\n    id\n    version\n    description\n    tags\n    labels\n  }\n}\n"
  }
};
})();

node.hash = "834e8e344fdc37524cb124e2946024fb";

module.exports = node;
